import { SxProps, Theme } from '@mui/material';

interface Styles {
  messageContainer: (isUserMessage: boolean) => SxProps<Theme>;
  messageBubble: (isUserMessage: boolean) => SxProps<Theme>;
  messageText: SxProps<Theme>;
  messageTime: SxProps<Theme>;
}

export const styles: Styles = {
  messageContainer: (isUserMessage) => ({
    alignSelf: isUserMessage ? 'flex-end' : 'flex-start',
    maxWidth: { xs: '90%', sm: '94%' },
    width: 'auto',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    ml: isUserMessage ? 'auto' : 0,
    mr: isUserMessage ? 0 : 'auto',
    px: 1
  }),

  messageBubble: (isUserMessage) => ({
    bgcolor: isUserMessage ? '#DCF8C6' : 'white',
    borderRadius: '12px',
    borderBottomLeftRadius: isUserMessage ? '12px' : 0,
    borderBottomRightRadius: isUserMessage ? 0 : '12px',
    px: { xs: 1.5, sm: 2 },
    py: { xs: 1, sm: 1.5 },
    position: 'relative',
    fontSize: { xs: 14, sm: 16 },
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    maxWidth: '100%',
  }),

  messageText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.5px',
    color: '#28272C',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    px: { xs: '0.7rem', sm: '0.4rem' }
  },

  messageTime: {
    mt: 0.5,
    textAlign: 'right',
    display: 'block',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: '#999EB0',
    fontFamily: 'Montserrat'
  }
}; 